export type PankoMap = { [key: string]: { name: string; title: string } };

export const panko: PankoMap = {
  "/": {
    name: "home",
    title: "ホーム"
  },
  "/buildings/:groupId": {
    name: "buildings-list",
    title: "建物リスト"
  },
  "/buildings/:groupId/:buildingId": {
    name: "building-details",
    title: "建物詳細"
  },
  "/buildings/:groupId/:buildingId/room/:roomGroupId/:roomId": {
    name: "room-details",
    title: "部屋詳細"
  },
  "/app-accounts/:groupId": {
    name: "app-accounts-list",
    title: "設置アプリアカウントリスト"
  },
  "/app-accounts/:groupId/:appUserId": {
    name: "app-account-details",
    title: "設置アプリアカウント詳細"
  },
  "/groups": {
    name: "groups-list",
    title: "グループリスト"
  },
  "/groups/:groupId": {
    name: "group-details",
    title: "グループ詳細"
  },
  "/groups/:groupId/users/:userId": {
    name: "group-user-details",
    title: "ユーザー詳細"
  },
  "/users": {
    name: "users-list",
    title: "ユーザー管理"
  },
  "/users/:userId": {
    name: "user-details",
    title: "ユーザー詳細"
  },
  "/my": {
    name: "my-details",
    title: "マイページ"
  },
  "/activity/:groupId": {
    name: "activity",
    title: "操作履歴"
  },
  "/alert": {
    name: "alert",
    title: "アラート"
  }
};

export interface PankoData {
  title: string;
  name: string;
}

export const getPanko = (path: string, map: PankoMap = panko): PankoData[] => {
  const result: PankoData[] = [];

  for (const key of Object.keys(map)) {
    if (
      key === "/" ||
      path.match(new RegExp(`^${key}/`)) ||
      path.match(new RegExp(`^${key}$`))
    ) {
      result.push(map[key]);
    }
  }

  return result;
};
